'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC, useEffect } from 'react'
import { useState } from 'react'

import { LinkField, linkUrl } from '@/lib/link'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxAssetbanner } from './Assetbanner'
import { AssetbannerProps } from './Assetbanner'
interface AssetbannerBlokProps {
  blok: {
    variant: any
    title: AssetbannerProps['title']
    subtitle: AssetbannerProps['subtitle']
    content: SbBlokData[]
    button: SbBlokData[]
    list: SbBlokData[]
    asset: any
    assetUrl: LinkField
    padding?: SbBlokData[]
    background?: SbBlokData[]
    text?: SbBlokData[]
    compact?: boolean
    imageFullWidthMobile?: boolean
    asset_width?: number
  } & SbBlokData
}

const Assetbanner: FC<AssetbannerBlokProps> = ({ blok }) => {
  const [list, setList] = useState([])
  const href = linkUrl(blok.assetUrl)

  let stylePanel = stylePanelSBData(blok.text, blok.background, '', blok.padding)

  useEffect(() => {
    // only return the .content
    let results: any = []
    if (blok.list) {
      blok.list.forEach((item) => {
        results.push(item.content)
      })
      setList(results)
    }
  }, [blok.list])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxAssetbanner
        variant={blok.variant}
        compact={blok.compact}
        title={blok.title}
        subtitle={blok.subtitle}
        content={
          blok.content &&
          blok.content.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        list={list}
        button={
          blok.button &&
          blok.button.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        asset={
          blok.asset &&
          blok.asset.filename && {
            src: blok.asset.filename,
            alt: blok.asset.alt,
            focus: blok.asset.focus,
          }
        }
        assetLink={
          blok.assetUrl && {
            url: href,
            target: blok.assetUrl.target,
          }
        }
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        imageFullWidthMobile={blok.imageFullWidthMobile}
        assetWidth={blok.asset_width}
      />
    </div>
  )
}

export default Assetbanner
